import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import DashboardLayout from "@/layouts/DashboardLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Guests from "@/pages/Guests";
import GuestProfile from "@/pages/GuestProfile";
import Segments from "@/pages/Segments";
import Email from "@/pages/Email";
import Automations from "@/pages/Automations";
import Reputation from "@/pages/Reputation";
import Chat from "@/pages/Chat";
import Voice from "@/pages/Voice";
import Analytics from "@/pages/Analytics";
import Surveys from "@/pages/Surveys";
import Alerts from "@/pages/Alerts";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Widget from "@/pages/Widget";
import SoysosTickets from "@/pages/SoysosTickets";
import SoysosStays from "@/pages/SoysosStays";
import SoysosReports from "@/pages/SoysosReports";
import SoysosWorkers from "@/pages/SoysosWorkers";
import Users from "@/pages/Users";
import AcceptInvite from "@/pages/AcceptInvite";
import GuestRequest from "@/pages/GuestRequest";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AuthGate() {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<AuthGate />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/widget/:propertyId" element={<Widget />} />
            <Route path="/soysos/request/:propertyId" element={<GuestRequest />} />
            <Route
              path="/app"
              element={<Protected><DashboardLayout /></Protected>}
            >
              <Route index element={<Dashboard />} />
              <Route path="guests" element={<Guests />} />
              <Route path="guests/:id" element={<GuestProfile />} />
              <Route path="segments" element={<Segments />} />
              <Route path="email" element={<Email />} />
              <Route path="automations" element={<Automations />} />
              <Route path="reputation" element={<Reputation />} />
              <Route path="chat" element={<Chat />} />
              <Route path="voice" element={<Voice />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="surveys" element={<Surveys />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="settings" element={<Settings />} />
              <Route path="users" element={<Users />} />
              <Route path="soysos" element={<SoysosTickets />} />
              <Route path="soysos/reports" element={<SoysosReports />} />
              <Route path="soysos/workers" element={<SoysosWorkers />} />
              <Route path="soysos/stays" element={<SoysosStays />} />
            </Route>
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
